import { render, staticRenderFns } from "./callout.vue?vue&type=template&id=5f7d2e3e&scoped=true&"
import script from "./callout.vue?vue&type=script&lang=js&"
export * from "./callout.vue?vue&type=script&lang=js&"
import style0 from "./callout.vue?vue&type=style&index=0&id=5f7d2e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7d2e3e",
  null
  
)

export default component.exports